import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { CritereComponent } from './critere.component';
import { CriteresComponent} from './criteres.component';

const routes: Routes = [
  {
    path: '',
    component: CriteresComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste/:type',
        component: CritereComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormationsRoutingModule { }

export const routedComponents = [
  CriteresComponent,
  CritereComponent
];
